import { ref, onMounted } from 'vue'
import { ItemWrapper } from '@/wrappers'
import { BuildingOfficeIcon } from '@heroicons/vue/24/outline'
import type { Object, FormData, FormInfo, DataFile, FormSelectOption, RequestType } from '@/interfaces'

export function useObject(skipLoading: boolean = false) {

    const baseForm: FormData = {
        name: null,
        company: null
    };

    const wrapper = new ItemWrapper<Object>("objects");

    const empty = {...baseForm};

    const request = ref<RequestType<FormData>>({
        isLoading: false,
        error: null,
        response: null,
        data: baseForm
    });

    const info = ref<FormInfo>();
    const objects = ref<Object[]>([]);
    const objectOptions = ref<FormSelectOption[]>([]);

    async function addObject(): Promise<void> {
        request.value = {...request.value , error: null , response: null , isLoading: !request.value.isLoading};

        await wrapper.addItem(getData()).then((data) => request.value.response = data.message)
            .catch((err) => request.value.error = err.response.data.message);

        request.value.data = {...empty};
        request.value.isLoading = !request.value.isLoading;
    }

    async function getObjects(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getItems().then((data) => objects.value = data);

        getAsFormOptions();
        request.value.isLoading = !request.value.isLoading;
    }

    function getAsFormOptions(): void {
        objectOptions.value = objects.value.map(object => {
            return {
                value: object.id,
                label: object.name,
                icon: BuildingOfficeIcon
            }
        });
    }

    async function getInfo(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getInfo().then((data) => info.value = data);

        request.value.isLoading = !request.value.isLoading;
    }

    function getData(): DataFile {
        return {
            file: null,
            data: JSON.stringify(request.value.data)
        }
    }

    onMounted(() => {
        if (skipLoading) return;

        getObjects();
    });

    return {
        info,
        request,
        objects,
        objectOptions,
        addObject,
        getInfo,
        getObjects
    }
}